"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkerLine;
var _react = _interopRequireDefault(require("react"));
var _reactKonva = require("react-konva");
var _Text = _interopRequireDefault(require("./Text"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["data", "name", "rotation", "formatDisplayTemperature", "strokeEnabled"]; // https://stackoverflow.com/a/70985651
// https://stackoverflow.com/a/67793914
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function StrokeOutline(_ref) {
  var _ref$start = _ref.start,
    start = _ref$start === void 0 ? {} : _ref$start,
    _ref$finish = _ref.finish,
    finish = _ref$finish === void 0 ? {} : _ref$finish,
    _ref$strokeEnabled = _ref.strokeEnabled,
    strokeEnabled = _ref$strokeEnabled === void 0 ? false : _ref$strokeEnabled;
  var strokeWidth = 2;
  if (strokeEnabled === false) return null;
  var dx = finish.X - start.X;
  var dy = finish.Y - start.Y;
  var rotation = Math.atan2(dy, dx) * 180 / Math.PI;
  var width = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) + strokeWidth;
  var offset = {
    x: Math.round(strokeWidth / 2),
    y: strokeWidth
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Rect, {
    name: "rect-stroke-line",
    x: start.X,
    y: start.Y,
    offset: offset,
    rotation: rotation,
    width: width,
    height: 4,
    stroke: "black",
    listening: false
  });
}
function MarkerLine(_ref2) {
  var data = _ref2.data,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? "marker-line" : _ref2$name,
    rotation = _ref2.rotation,
    formatDisplayTemperature = _ref2.formatDisplayTemperature,
    _ref2$strokeEnabled = _ref2.strokeEnabled,
    strokeEnabled = _ref2$strokeEnabled === void 0 ? false : _ref2$strokeEnabled,
    listeners = _objectWithoutProperties(_ref2, _excluded);
  var characteristics = data.characteristics,
    markerPixelIndexStart = data.markerPixelIndexStart,
    markerPixelIndexFinish = data.markerPixelIndexFinish,
    markerPixelIndexStart_OutputImageCoordinates = data.markerPixelIndexStart_OutputImageCoordinates,
    markerPixelIndexFinish_OutputImageCoordinates = data.markerPixelIndexFinish_OutputImageCoordinates;
  var start = markerPixelIndexStart_OutputImageCoordinates !== null && markerPixelIndexStart_OutputImageCoordinates !== void 0 ? markerPixelIndexStart_OutputImageCoordinates : markerPixelIndexStart;
  var finish = markerPixelIndexFinish_OutputImageCoordinates !== null && markerPixelIndexFinish_OutputImageCoordinates !== void 0 ? markerPixelIndexFinish_OutputImageCoordinates : markerPixelIndexFinish;
  var tension = 1;
  var labelOffset = 15;
  var tempMax = formatDisplayTemperature(characteristics.markerTempC_Max);
  var tempMin = formatDisplayTemperature(characteristics.markerTempC_Min);
  var midpointX = (start.X + finish.X) / 2;
  var midpointY = (start.Y + finish.Y) / 2;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Line, _objectSpread({
      name: name,
      points: [start.X, start.Y, finish.X, finish.Y],
      stroke: "white",
      tension: tension
    }, listeners)), /*#__PURE__*/(0, _jsxRuntime.jsx)(StrokeOutline, {
      start: start,
      finish: finish,
      strokeEnabled: strokeEnabled
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      x: start.X,
      y: start.Y,
      offset: {
        x: labelOffset,
        y: labelOffset
      },
      text: characteristics.markerName,
      rotation: rotation,
      stroke: "black",
      strokeWidth: 2
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      x: midpointX,
      y: midpointY - labelOffset,
      text: "Max: ".concat(tempMax, "\nMin: ").concat(tempMin),
      rotation: rotation,
      stroke: "black",
      strokeWidth: 2
    })]
  });
}